<template>
    <div>
        <el-dialog title="打印方案" :visible.sync="show" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <div class="pd">
                <el-button type="primary" size="mini" style="margin-bottom: 10px" v-if="opmAdmin == 1" @click="addPlan(time())">新增</el-button>
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="printName" label="方案名称"> </el-table-column>
                    <el-table-column prop="printDesc" label="说明"> </el-table-column>
                    <el-table-column label="操作" :width="!zdIsPrint ? '300' : '200'">
                        <template slot-scope="scope">
                            <el-row>
                                <el-button type="primary" size="mini" plain v-if="oper" :disabled="disabled" @click="previewReport(scope.row, 'preview')">预览</el-button>
                                <template v-if="!zdIsPrint">
                                    <el-button class="print-press-btn" v-if="printTasks.length > 0" type="primary" size="mini" :disabled="disabled" @click="previewReportII(scope.row, 'print')">打印</el-button>
                                    <el-button class="print-press-btn" v-else-if="printTasks.length == 0" type="primary" size="mini" :disabled="disabled" @click="previewReport(scope.row, 'print')">打印</el-button>
                                </template>
                                <el-button type="primary" size="mini" v-if="opmAdmin == 1" @click="changePlan(scope.row)">修改</el-button>
                                <el-button type="danger" v-if="opmAdmin == 1" size="mini" @click="delPlan(scope.row)">删除
                                </el-button>
                                <!-- <el-button
                  v-if="opmAdmin == 1"
                  type="primary"
                  size="mini"
                  @click="printDesign(scope.row)"
                  >打印设计
                </el-button> -->
                            </el-row>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog :title="drawerTitle" :visible.sync="dialogFormVisible" :modal-append-to-body="true" :append-to-body="true">
            <el-form :model="printform" :rules="rules" ref="printform">
                <el-form-item label="方案名称" prop="printName">
                    <el-input v-model="printform.printName" autocomplete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="方案说明" prop="printDesc">
                    <el-input v-model="printform.printDesc" autocomplete="off" type="textarea" clearable></el-input>
                </el-form-item>
                <el-button type="primary" @click="printDesign" plain>模板设计</el-button>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm('printform')" v-if="operType == 0">
                    新增
                </el-button>
                <el-button type="primary" @click="confirm('printform')" v-if="operType == 1">
                    修改
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from "vue";
import {
    getPrintDataById,
    addPrintPlan,
    updatePrintPlan,
    delPrintPlan,
    queryPrintCount,
} from "@/service/printApi.js";
export default {
    name: "printPlan",
    components: {},
    data() {
        return {
            tableData: [],
            show: false,
            printData: {},
            dhId: "", //单号
            userData: [],
            reportmod: "",
            printJurId: "",
            printSouce: "",
            printType: "",
            oper: true,
            isAll: false,
            reportParams: {},
            reportParamsBl: false,
            opmAdmin: JSON.parse(sessionStorage.getItem("userInfo")).opmAdmin,
            jurId: "",
            dialogFormVisible: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "",
                actionType: 0, // 0新增，1修改
            },
            printform: {
                printName: "",
                printDesc: "",
                printContent: "",
            },
            rules: {
                printName: [
                    { required: true, message: "请输入方案名称", trigger: "blur" },
                ],
            },
            tableData: [],
            pldata: '',
            systemFormList: [],
            selectForm: "",
            drawer: false,
            formData: {},
            classifyInfo: [],
            classifyType: [],
            defaultParams: {
                label: "jurName",
                value: "jurId",
                children: [],
            },
            classifySelValue: "",
            showData: {},
            drawerTitle: "",
            ids: [],
            allDataList: [],
            printDataUrl: "",
            reportmod: "",
            idParams: {},
            operType: 0,
            loading: false,
            someUserData: false,
            type: null,
            previewShow: "",
            disabled: false,
            currentIsMag: null, // 当前打印任务的isMag参数
            printTasks: [],
            zdIsPrint: false,
        };
    },
    props: {},
    watch: {
        show(newVal, oldVal) {
            if (!newVal) {
                this.$emit('close')
            }
        }
    },
    computed: {},
    mounted() { },
    created() { },
    methods: {
        // 新增初始化
        init() {
            for (let key in this.printform) {
                this.printform[key] = "";
            }
            this.$printReportMod = "";
            this.reportmod = "";
        },
        // 新增方案
        confirm(printform, type) {
            // if (type == 0) {

            // }
            if (this.printform.printName == "")
                return this.$message({
                    message: "请填写方案名称",
                    type: "warning",
                });

            if (Vue.prototype.$printReportMod == "")
                return this.$message({
                    message: "请先进行模板设计",
                    type: "warning",
                });

            let params = {
                jurId: this.jurId.toString(),
                printContent: Vue.prototype.$printReportMod,
                printDesc: this.printform.printDesc,
                printName: this.printform.printName,
                printId: this.printform.printId,
            };
            var token = sessionStorage.getItem("token");
            if (this.operType == 0) {
                addPrintPlan(params, token).then((res) => {
                    if (res.status === 200) {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: "新增成功",
                            type: "success",
                        });
                        this.getPrintPlanById(this.idParams);
                        // this.userData = res.result
                    }
                });
            } else {
                updatePrintPlan(params, token).then((res) => {
                    if (res.status === 200) {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: "修改成功",
                            type: "success",
                        });
                        this.getPrintPlanById(this.idParams);
                        // this.userData = res.result
                    }
                });
            }
        },
        // 新增打印方案
        addPlan(e) {
            Vue.prototype.$printReportMod = ''
            Vue.prototype.$printReportKey = e;
            // this.formData = this.defaultData;
            this.operType = 0;
            this.init();
            this.printform = {};
            this.drawerTitle = "新增";
            this.dialogFormVisible = true;
        },
        // 修改打印方案
        changePlan(row) {
            console.log(row);
            this.drawerTitle = "修改";
            this.operType = 1;
            this.printform = row;
            Vue.prototype.$printReportMod = ''
            Vue.prototype.$printReportKey = row.printId;
            this.reportmod = row.printContent;
            this.dialogFormVisible = true;
        },
        //设计
        sendbutton: function () {
            //alert(JSON.stringify(jomsg));
            jomsg2.data.route = "design";
            webSocket.send(JSON.stringify(jomsg3));
        },

        //预览
        privewbutton: function () {
            jomsg2.data.route = "preview";
            //alert(JSON.stringify(jomsg));
            webSocket.send(JSON.stringify(jomsg));
        },

        //打印
        printbutton: function () {
            jomsg2.data.route = "print";
            //alert(JSON.stringify(jomsg));
            webSocket.send(JSON.stringify(jomsg3));
        },
        time() {
            var time = Math.round(new Date() / 1000);
            return time;
        },
        printDesign() {
            var token = sessionStorage.getItem("token");
            if (this.operType == 0) {
                if (this.someUserData) {
                    var params = {
                        id: [],
                        isPrint: 0,
                    };
                } else {
                    console.log(this.printSouce);
                    if (Object.prototype.toString.call(this.dhId) == '[object Array]') {
                        if (this.printSouce == "printData/decaFeetick") {
                            var params = {
                                ids: this.dhId,
                            };
                        } else {
                            var params = {
                                id: this.dhId[0],
                                isPrint: 0,
                            };
                        }
                    } else {
                        var params = {
                            id: this.dhId,
                            isPrint: 0,
                        };
                    }


                }
                if (this.dhId == '报表打印') {
                    this.userData = this.pldata.data.param.userdata
                    this.$printSocketApi.designReport(
                        this.userData,
                        this.reportmod,
                        this.printform.printName
                    );

                } else {

                    getPrintDataById(params, this.printSouce, token).then((res) => {
                        this.userData = res.result
                        if (res.status === 200) {
                            if (this.printSouce == 'printData/suOrderBookkeepingZj') {
                                this.userData.forEach(item => {
                                    if (item.tableName == 'zj') {
                                        item.rows.forEach(row => {
                                            row.fileUrl = `${window.global_config.BASE_IMG_URL}/${row.fileUrl}`
                                        })
                                    }
                                })
                                console.log(this.userData, "测试");
                                this.$printSocketApi.designReport(
                                    this.userData,
                                    this.reportmod,
                                    this.printform.printName
                                );
                            } else {
                                this.$printSocketApi.designReport(
                                    this.userData,
                                    this.reportmod,
                                    this.printform.printName
                                );
                            }

                        }
                    });
                }


            } else if (this.operType == 1) {
                let id = this.dhId

                if (this.printSouce == "printData/decaFeetick") {
                    var params = {
                        ids: this.dhId,
                    };
                } else if (this.someUserData) {
                    var params = {
                        id,
                        isPrint: 1,
                    };
                } else {
                    if (typeof id == 'object') {
                        id = id[0]
                    }
                    var params = {
                        id,
                        isPrint: 1,
                    };
                }

                if (this.dhId == '报表打印') {
                    Vue.prototype.$printReportKey = this.printform.printId;
                    this.userData = this.pldata.data.param.userdata
                    this.$printSocketApi.designReport(
                        this.userData,
                        this.reportmod,
                        this.printform.printName
                    );

                } else {
                    console.log(this.printform);
                    Vue.prototype.$printReportKey = this.printform.printId;
                    getPrintDataById(params, this.printSouce, token).then((res) => {
                        if (res.status === 200) {
                            this.userData = res.result;
                            if (this.printSouce == 'printData/suOrderBookkeepingZj') {
                                this.userData.forEach(item => {
                                    if (item.tableName == 'zj') {
                                        item.rows.forEach(row => {
                                            row.fileUrl = `${window.global_config.BASE_IMG_URL}/${row.fileUrl}`
                                        })
                                    }
                                })
                                this.$printSocketApi.designReport(
                                    this.userData,
                                    this.reportmod,
                                    this.printform.printName
                                );
                            } else {
                                this.$printSocketApi.designReport(
                                    this.userData,
                                    this.reportmod,
                                    this.printform.printName
                                );
                            }
                        }
                        // resolve();
                    });
                }
            }
        },
        // 通过ID获取检索方案
        async getPrintPlanById(params) {
            var responseData = await this.$http.getPrintPlanById(params);
            console.log(responseData);
            if (responseData.status == 200) {

                this.tableData = responseData.result;
                if (this.previewShow == 'oper') {
                    this.previewReport(this.tableData[0], 'preview')
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 打开方案弹窗 //dhId:打印的数据，printSouce:生成打印数据的接口，printJurId:打印方案Id，oper:是否显示预览，isAll:是否批量打印，
        //reportParams:是否是报表打印，someUserData:不确定自己看，data:报表打印数据，type:指定字段从大到小排序
        openDia(dhId, printSouce, printJurId, oper, isAll, reportParams, someUserData, data, type) {
            console.log(dhId, printSouce, printJurId, oper, isAll, reportParams, someUserData, data, type);

            if (type) this.type = type
            console.log(dhId, 'dhId数据');
            console.log(printSouce, 'printSouce数据', printJurId, 'printJurId数据', oper, 'oper数据', isAll, 'isAll数据');
            console.log(reportParams, 'reportParams数据');
            console.log(someUserData, "someUserData数据");
            console.log(data, "data数据");
            console.log(type, "type数据");
            if (reportParams) {
                this.reportParams = reportParams;
                this.reportParamsBl = true;
            }
            if (someUserData == 'someUserData') this.someUserData = true
            if (data) this.pldata = data
            this.oper = oper == "closeYl" ? false : true; //不显示预览
            this.previewShow = oper//是否直接预览不用弹出列表 数据位“oper”的直接弹出打印预览否则弹出打印模版列表
            this.dhId = dhId;
            this.isAll = isAll == "all" ? true : false; //批量打印
            if (printSouce) {
                this.printSouce = printSouce;
            } else {
                this.printSouce = sessionStorage.getItem('printSource').replace(/\"/g, "");
            }
            var jurId = printJurId.toString().split(",");
            this.jurId = jurId;
            // else var jurId = sessionStorage.getItem('printJurId')
            this.idParams = {
                ids: jurId,
            };
            if (this.previewShow != "oper") {
                this.show = true;
            }
            this.getPrintPlanById(this.idParams);

        },
        // 通过ID获取打印方案模拟数据
        async previewReport(row, type) {
            if (this.printSouce == '/printData/printTemplatePrint') {
                this.$http.chargekdnStatus({ ids: this.pldata })
            }

            this.printType = type;
            var token = sessionStorage.getItem("token");
            this.reportmod = row.printContent;
            const list = []
            if (this.isAll) {
                for (let i = 0; i < this.dhId.length; i++) {
                    const item = this.dhId[i];
                    let params = {
                        id: item,
                        isPrint: 1,
                    };
                    // 只有在打印模式下才添加isMag参数，预览模式不需要
                    if (type === 'print' && this.currentIsMag !== null) {
                        params.isMag = this.currentIsMag;
                    }
                    try {
                        const res = await getPrintDataById(params, this.printSouce, token);
                        if (res.status === 200) {
                            this.userData = res.result;
                            console.log("this.userData", this.userData);
                            if (this.userData[0].print) {
                                params = {
                                    id: item,
                                    isPrint: 1,
                                };
                            } else {
                                params = {
                                    id: [item],
                                    isPrint: 1,
                                };
                            }

                            // 只有在打印模式下才添加isMag参数，预览模式不需要
                            if (type === 'print' && this.currentIsMag !== null) {
                                params.isMag = this.currentIsMag;
                            }

                            const result = await queryPrintCount(params, token);
                            if (result.status === 200) {
                                if (res.result.length == 0) {
                                    list.push(res.result[0])
                                    if (list.length === this.dhId.length) {
                                        this.disabled = false
                                        if (type == 'print' && window.global_config.printShow) {
                                            this.show = false
                                        }
                                        this.$printSocketApi.previewReport(
                                            list,
                                            this.reportmod,
                                            this.printType,
                                            row.printName,
                                            result.result.printCount,//打印次数
                                            row.printId,
                                            'true',
                                            "false"
                                        );
                                    }
                                } else {
                                    list.push({
                                        list: res.result
                                    })
                                    if (list.length === this.dhId.length) {
                                        var arr = []
                                        if (this.type) {
                                            this.dhId.forEach(val => {
                                                arr.push(list.filter(item => item['list'][0].rows[0][this.type] == val)[0])
                                            })
                                        } else {
                                            arr = list
                                        }
                                        this.disabled = false
                                        if (type == 'print' && window.global_config.printShow) {
                                            this.show = false
                                        }
                                        this.$printSocketApi.previewReport(
                                            arr,
                                            this.reportmod,
                                            this.printType,
                                            row.printName,
                                            result.result.printCount,//打印次数
                                            row.printId,
                                            'true',
                                            'true'
                                        );
                                    }
                                }
                            } else {
                                this.$message({
                                    message: result.message,
                                    type: "error",
                                });
                            }
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    } catch (err) {
                        this.$message({
                            message: err.message || '请求异常',
                            type: "error",
                        });
                    }
                }
                return;
            }
            if (this.reportParamsBl) {
                let params = this.reportParams;

                // 只有在打印模式下才添加isMag参数，预览模式不需要
                if (type === 'print' && this.currentIsMag !== null) {
                    params.isMag = this.currentIsMag;
                }

                // if (this.printType == '')
                if (this.dhId == '报表打印') {
                    this.pldata.data.route = 'preview'
                    this.userData = this.pldata.data.param.userdata
                    this.disabled = false
                    if (type == 'print' && window.global_config.printShow) {
                        this.show = false
                    }
                    this.$printSocketApi.previewReport(
                        this.userData,
                        this.reportmod,
                        this.printType,
                        row.printName,
                        0,
                        row.printId

                    );
                } else {
                    getPrintDataById(params, this.printSouce, token).then((res) => {
                        if (res.status === 200) {
                            this.userData = res.result;
                            console.log("this.userData", this.userData);
                            this.disabled = false
                            if (type == 'print' && window.global_config.printShow) {
                                this.show = false
                            }
                            this.$printSocketApi.previewReport(
                                this.userData,
                                this.reportmod,
                                this.printType,
                                row.printName,
                                0,
                                row.printId

                            );
                        }
                        // resolve();
                    });
                }

                return;
            }
            var params = {}
            if (this.printSouce == 'printData/decaFeetick') {
                params = {
                    ids: this.dhId,
                    isPrint: 1,
                };
            } else {
                params = {
                    id: this.dhId,
                    isPrint: 1,
                };
            }

            // 只有在打印模式下才添加isMag参数，预览模式不需要
            if (type === 'print' && this.currentIsMag !== null) {
                params.isMag = this.currentIsMag;
                console.log('添加isMag参数到getPrintDataById:', this.currentIsMag, params);
            }

            getPrintDataById(params, this.printSouce, token).then((res) => {
                if (res.status === 200) {
                    this.userData = res.result;
                    console.log("this.userData", this.userData);
                    if (this.userData[0].print) {
                        var params = {
                            id: this.dhId,
                            isPrint: 1,
                        };
                    } else {
                        var params = {
                            id: [this.dhId],
                            isPrint: 1,
                        };
                    }

                    // 只有在打印模式下才添加isMag参数，预览模式不需要
                    if (type === 'print' && this.currentIsMag !== null) {
                        params.isMag = this.currentIsMag;
                    }
                    if (this.printSouce == 'printData/decaFeetick') {
                        this.disabled = false
                        if (type == 'print' && window.global_config.printShow) {
                            this.show = false
                        }
                        this.$printSocketApi.previewReport(
                            this.userData,
                            this.reportmod,
                            this.printType,
                        )
                    } else {
                        queryPrintCount(params, token).then((result) => {
                            if (result.status === 200) {
                                this.disabled = false
                                if (type == 'print' && window.global_config.printShow) {
                                    this.show = false
                                }

                                if (this.printSouce == 'printData/suOrderBookkeepingZj') {
                                    this.userData.forEach(item => {
                                        if (item.tableName == 'zj') {
                                            item.rows.forEach(row => {
                                                row.fileUrl = `${window.global_config.BASE_IMG_URL}/${row.fileUrl}`
                                            })
                                        }
                                    })
                                    this.$printSocketApi.previewReport(
                                        this.userData,
                                        this.reportmod,
                                        this.printType,
                                        row.printName,
                                        result.result.printCount, //打印次数
                                        row.printId
                                    )
                                } else {
                                    this.$printSocketApi.previewReport(
                                        this.userData,
                                        this.reportmod,
                                        this.printType,
                                        row.printName,
                                        result.result.printCount, //打印次数
                                        row.printId
                                    )
                                }
                            } else {
                                this.$message({
                                    message: result.message,
                                    type: "error",
                                });
                            }
                        });
                    }
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    });
                }
                // resolve();
            });
            // });
        },
        async previewReportII(row, type) {
            // 根据printTasks循环执行打印任务
            if (this.printTasks && this.printTasks.length > 0) {
                console.log('开始执行打印任务，任务数量:', this.printTasks.length);

                for (let i = 0; i < this.printTasks.length; i++) {
                    const task = this.printTasks[i];
                    console.log(`执行第${i + 1}个打印任务:`, task);

                    // 设置当前任务的isMag参数
                    this.currentIsMag = task.isMag;
                    console.log('设置currentIsMag为:', this.currentIsMag);

                    // 执行单个打印任务
                    await this.executeSinglePrintTaskII(row, type, task);

                    // 多任务间添加延迟，避免冲突
                    if (i < this.printTasks.length - 1) {
                        console.log('等待1秒后执行下一个任务...');
                        await new Promise(resolve => setTimeout(resolve, 1000));
                    }
                }

                console.log('所有打印任务执行完成');
                return;
            }

            // 如果没有printTasks，执行原有逻辑
            console.log('没有printTasks，执行原有打印逻辑');
            await this.executeSinglePrintTaskII(row, type, null);
        },

        // 执行单个打印任务的核心逻辑
        async executeSinglePrintTaskII(row, type, task) {
            if (this.printSouce == '/printData/printTemplatePrint') {
                this.$http.chargekdnStatus({ ids: this.pldata })
            }
            this.printType = type;
            var token = sessionStorage.getItem("token");
            this.reportmod = row.printContent;
            const list = []

            if (this.reportParamsBl) {
                let params = this.reportParams;

                // 如果有isMag参数，添加到params中
                if (this.currentIsMag !== null) {
                    params.isMag = this.currentIsMag;
                }

                // if (this.printType == '')
                if (this.dhId == '报表打印') {
                    this.pldata.data.route = 'preview'
                    this.userData = this.pldata.data.param.userdata
                    this.disabled = false
                    if (type == 'print' && window.global_config.printShow) {
                        this.show = false
                    }
                    this.$printSocketApi.previewReport(
                        this.userData,
                        this.reportmod,
                        this.printType,
                        row.printName,
                        0,
                        row.printId

                    );
                } else {
                    return new Promise((resolve, reject) => {
                        getPrintDataById(params, this.printSouce, token).then((res) => {
                            if (res.status === 200) {
                                this.userData = res.result;
                                console.log("this.userData", this.userData);
                                this.disabled = false
                                if (type == 'print' && window.global_config.printShow) {
                                    this.show = false
                                }
                                this.$printSocketApi.previewReport(
                                    this.userData,
                                    this.reportmod,
                                    this.printType,
                                    row.printName,
                                    0,
                                    row.printId

                                );
                                resolve();
                            } else {
                                reject(res);
                            }
                        }).catch(reject);
                    });
                }

                return;
            }

            return new Promise((resolve, reject) => {
                var params = {}
                if (this.printSouce == 'printData/decaFeetick') {
                    params = {
                        ids: this.dhId,
                        isPrint: 1,
                    };
                } else {
                    params = {
                        id: this.dhId,
                        isPrint: 1,
                    };
                }

                // 如果有isMag参数，添加到params中
                if (this.currentIsMag !== null) {
                    params.isMag = this.currentIsMag;
                    console.log('添加isMag参数到getPrintDataById:', this.currentIsMag, params);
                }

                getPrintDataById(params, this.printSouce, token).then((res) => {
                    if (res.status === 200) {
                        this.userData = res.result;
                        console.log("this.userData", this.userData);
                        if (this.userData[0].print) {
                            var params = {
                                id: this.dhId,
                                isPrint: 1,
                            };
                        } else {
                            var params = {
                                id: [this.dhId],
                                isPrint: 1,
                            };
                        }

                        // 如果有isMag参数，添加到params中
                        if (this.currentIsMag !== null) {
                            params.isMag = this.currentIsMag;
                        }
                        if (this.printSouce == 'printData/decaFeetick') {
                            this.disabled = false
                            if (type == 'print' && window.global_config.printShow) {
                                this.show = false
                            }
                            this.$printSocketApi.previewReport(
                                this.userData,
                                this.reportmod,
                                this.printType,
                            )
                            resolve();
                        } else {
                            queryPrintCount(params, token).then((result) => {
                                if (result.status === 200) {
                                    this.disabled = false
                                    if (type == 'print' && window.global_config.printShow) {
                                        this.show = false
                                    }
                                    this.$printSocketApi.previewReport(
                                        this.userData,
                                        this.reportmod,
                                        this.printType,
                                        row.printName,
                                        result.result.printCount, //打印次数
                                        row.printId
                                    )
                                    resolve();
                                } else {
                                    this.$message({
                                        message: result.message,
                                        type: "error",
                                    });
                                    reject(result);
                                }
                            }).catch(reject);
                        }
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error",
                        });
                        reject(res);
                    }
                }).catch(reject);
            });
        },
        // 新的打开方案弹窗方法，支持根据magCount和notMagCount判断打印次数和isMag参数
        // dhId:打印的数据，printSouce:生成打印数据的接口，printJurId:打印方案Id，responseData:包含magCount和notMagCount的响应数据
        openDiaII(dhId, printSouce, printJurId, responseData) {
            console.log('openDiaII调用参数:', dhId, printSouce, printJurId, responseData);
            if (!responseData || !responseData.result) {
                console.error('responseData或result为空');
                return;
            }

            const { magCount, notMagCount } = responseData.result;
            console.log('magCount:', magCount, 'notMagCount:', notMagCount);

            // 根据返回的数据判断需要打印的次数和参数
            this.printTasks = [];

            // magCount有值时，添加isMag=1的打印任务
            if (magCount && magCount > 0) {
                this.printTasks.push({
                    isMag: 1,
                    count: magCount,
                    type: '带票'
                });
            }

            // notMagCount有值时，添加isMag=0的打印任务
            if (notMagCount && notMagCount > 0) {
                this.printTasks.push({
                    isMag: 0,
                    count: notMagCount,
                    type: '不带票'
                });
            }

            if (this.printTasks.length === 0) {
                console.log('没有需要打印的任务');
                return;
            }

            console.log('打印任务列表:', this.printTasks);
            this.openDia(dhId, printSouce, printJurId);

        },


        // 删除打印方案
        delPlan(row) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.del(row);
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        del(row) {
            let params = {
                ids: [row.printId],
            };
            var token = sessionStorage.getItem("token");
            delPrintPlan(params, token).then((res) => {
                if (res.status === 200) {
                    this.getPrintPlanById(this.idParams);
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                }
            });
        },
    },
};
</script>
<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}

.pd {
    padding-bottom: 20px;
}

.print-press-btn:active {
    background-color: #ebb563 !important;
    border-color: #ebb563 !important;
    color: #fff !important;
}
</style>